export default __webpack_public_path__ + "static/media/porterRobinson.3560fedf.jpeg";